import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import LoginForm from '../../components/LoginForm/LoginForm';
import styles from './LoginPage.module.css';

const LoginPage: React.FC = () => {
  const { isAuthenticated, login } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleSubmit = async (username: string, password: string): Promise<void> => {
    setError(null);
    setIsLoading(true);

    try {
      await login(username, password);
      // Navigation will happen automatically via the redirect above
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred during login');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.loginPage}>
      <div className={styles.formColumn}>
        <LoginForm onSubmit={handleSubmit} error={error} isLoading={isLoading} />
      </div>
      <div className={styles.heroColumn}>
        <div className={styles.heroOverlay}></div>
        <div className={styles.heroContent}>
          <h2 className={styles.heroTitle}>Complete Account Management</h2>
          <p className={styles.heroSubtitle}>
            Manage parties, tokens, transactions, ledgers, and generate comprehensive reports.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
